var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "text-bubble"
  }, [_vm.$slots.mms ? _c('div', {
    staticClass: "mms"
  }, [_vm._t("mms"), _c('v-divider')], 2) : _vm._e(), _c('svg', {
    staticClass: "tail",
    attrs: {
      "viewBox": "0 0 30 20"
    }
  }, [_c('mask', {
    attrs: {
      "id": "m"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "100%",
      "height": "100%",
      "fill": "#FFF"
    }
  }), _c('ellipse', {
    attrs: {
      "cx": "-10",
      "cy": "-23",
      "rx": "25",
      "ry": "45",
      "fill": "#000"
    }
  })]), _c('ellipse', {
    attrs: {
      "cx": "-15",
      "cy": "-25",
      "rx": "50",
      "ry": "45",
      "mask": "url(#m)"
    }
  })]), _vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }